<template>
  <div
    v-if="showWarning && isSbImage(blok) && blok.warning_text"
    class="w-full px-5 py-2"
    :style="{
      backgroundColor: warningBackgroundColor,
      color: warningTextColor || '#000000',
    }"
  >
    <p :class="textClass">{{ blok.warning_text }}</p>
  </div>
</template>

<script setup lang="ts">
import { isSbImage } from '~/utils/typeguards'
import type { SbImage } from '../types/storyblok'
import { parseColor } from '~/utils/storyblok'

const currentShop = useCurrentShop()

const props = defineProps<{
  blok: SbImage
}>()

const textClass = computed(() => {
  return currentShop.value?.legalDisclaimerEnhanced
    ? 'text-lg font-semibold'
    : 'text-sm'
})

const showWarning = computed(() => {
  return isSbImage(props.blok) ? !!props.blok.include_disclaimer : false
})

const warningTextColor = computed(() => {
  return isSbImage(props.blok) && parseColor(props.blok.warning_color)
})

const warningBackgroundColor = computed((): string => {
  if (!isSbImage(props.blok)) return ''
  const color = parseColor(props.blok.warning_background_color) || ''
  if (
    props.blok.warning_position === 'on-image' &&
    !currentShop.value?.legalDisclaimerEnhanced
  ) {
    return `${color}b3`
  }
  return color
})
</script>
